type Args = {
	readonly isWithdrawn: boolean;
	readonly grantedAt: Date;
	readonly grantedByName: string | null;
	readonly withdrawnAt: Date | null;
	readonly withdrawnByName: string | null;
	readonly consentId: number | null;
};

/**
 * A subject's consent, resolved from whichever of the two sources answered. `grantedByName` and
 * `consentId` are `null` on the device-only path: the name of who consented, and the server's own
 * identifier for the consent row, are both written server-side at composite creation, never on this
 * device — inventing either here would present a deduction as a consigned fact. `isWithdrawn` is a
 * plain field rather than a derived getter, since a device-only consent is never withdrawn: there is
 * no server row to carry that state yet.
 */
class InternalInterviewConsentView {
	readonly isWithdrawn: boolean;
	readonly grantedAt: Date;
	readonly grantedByName: string | null;
	readonly withdrawnAt: Date | null;
	readonly withdrawnByName: string | null;
	readonly consentId: number | null;

	constructor(parts: Args) {
		this.isWithdrawn = parts.isWithdrawn;
		this.grantedAt = parts.grantedAt;
		this.grantedByName = parts.grantedByName;
		this.withdrawnAt = parts.withdrawnAt;
		this.withdrawnByName = parts.withdrawnByName;
		this.consentId = parts.consentId;

		Object.freeze(this);
	}
}

export default InternalInterviewConsentView;
